// Copyright (c) 2017 TrainHeroic LLC
// Context menu actions for a Workout on a calendar

export default {
    PUBLISH: 'publish',
    PREVIEW: 'preview',
    SAVE: 'save-to-library',
    EDIT: 'edit',
    COPY: 'copy',
    DELETE: 'delete',
    REPEAT: 'repeat'
};
